import { CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export const WhyNorex = () => {
  const { t } = useLang();
  return (
  <section id="why-norex" data-testid="why-norex-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
      <div className="lg:col-span-6">
        <Reveal>
          <Eyebrow>{t.why.eyebrow}</Eyebrow>
          <h2 className="text-3xl md:text-4xl tracking-tight font-bold text-[#F4F6F8]">
            {t.why.title}
          </h2>
          <p className="mt-6 text-base text-[#94A3B8] leading-relaxed max-w-lg">
            {t.why.body}
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-6">
        <ul className="divide-y divide-[#1E293B] border-y border-[#1E293B]">
          {t.why.points.map((point, i) => (
            <Reveal key={i} delay={i * 0.05} y={20}>
              <li
                data-testid={`why-point-${i + 1}`}
                className="group flex items-center gap-4 py-5 px-2 hover:bg-surface transition-colors duration-200"
              >
                <CheckCircle2 className="w-5 h-5 text-gold shrink-0" />
                <span className="text-base md:text-lg text-[#F4F6F8] font-medium">{point}</span>
                <span className="ml-auto font-display text-sm text-[#94A3B8]/40 group-hover:text-gold transition-colors duration-200">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </div>
  </section>
  );
};
